












import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import { Function, Post } from "../../Classes/Entities";

@Component
export default class Announcement extends Vue {
  @Prop() 
  public function!: Function<Post>;

  @Emit()
  public input(value:string){
  }
  
  private get name(): string {
    return this.function.name;
  }
  
  private set name(value:string) {
    //return this.function.name;
  }

  private get href():string {
    return '/announcement/' + this.function.id;
  }
  
  private set href(value:string) {
  }
}
